import * as React from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

const sizeMap = { small: "sm", medium: "default", large: "lg" };

const TertiaryButton = React.forwardRef(
  ({ size = "medium", fullWidth = false, className, ...props }, ref) => (
    <Button
      ref={ref}
      variant="outline"
      size={sizeMap[size] || "default"}
      className={cn(fullWidth && "w-full", className)}
      {...props}
    />
  ),
);
TertiaryButton.displayName = "TertiaryButton";

export default TertiaryButton;
